import React, { useState, useEffect, useRef, useContext } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import TContext from '../context';
import { Toast, Empty, Infiniteloading } from '@nutui/nutui-react';
import http, { uploadFile } from '../../../lib/http';
import * as apis from '../../../lib/apis';
import { cloneDeep } from 'lodash';
import UploadIcon from '../../../static/img/upload_img.png';

interface Props {
    action?: any;
}

export interface Action {
    confirm?: () => boolean;
    // cancel?: () => void;
}


const groupHeight = 40;
const titleHeight = 30;
export const Height = groupHeight;

let previewPatternObject: any = null;
interface Props {
    onConfirmSuccess?: () => void
}
const Index = ({ onConfirmSuccess, preloadedData, dataLoading = false }: Props & { preloadedData?: any; dataLoading?: boolean }) => {
    const page = useRef(1);
    const categoryId = useRef(0);
    const [patternGroups, setPatternGroups] = useState<any>([]);
    const [patternList, setPatternList] = useState({ list: [], total: 0 });
    const [currentPatternId, setCurrentPatternId] = useState(-1);
    const [curPatternGroupId, setCurPatternGroupId] = useState<number>(0);
    const tc = useContext(TContext);
    const uploadRef = useRef<any>();
    const hasLoaded = useRef(false);
    const hasInitialized = useRef(false);

    useEffect(() => {
        if (preloadedData && !hasInitialized.current) {
            // 设置分类数据
            if (preloadedData.patternGroups?.list) {
                const groups = [{ id: 0, name: "全部" }, ...preloadedData.patternGroups.list];
                setPatternGroups(groups);
            }

            // 设置图案列表数据
            if (preloadedData.patternObj) {
                setPatternList(preloadedData.patternObj);
            }

            setCurPatternGroupId(0);
            hasInitialized.current = true;
        }
    }, [preloadedData]);

    const initData = async () => {
        // 如果已经有预加载数据，就不需要再次初始化
        if (hasInitialized.current) {
            return;
        }
        previewPatternObject = null;
        Toast.loading(t("加载中"), { cover: true, closeOnClickOverlay: false, duration: 0 });
        page.current = 1;
        try {
            const patternGroups: any = await http.get(apis.DESIGNER_PATTERN_CATEGORY, {
                params: { page: page.current, limit: 10 }
            });
            patternGroups?.list?.unshift({ id: 0, name: "全部" });
            setPatternGroups(patternGroups?.list);
            await loadPatternList();
            setCurPatternGroupId(0);
            hasInitialized.current = true;
        } catch (error) { }
        Toast.hide();
    };
    useEffect(() => {
        if (tc.preloadTrigger && !hasInitialized.current) {
            initData();
        }
    }, [tc.preloadTrigger]);

    const previewPattern = async (v: any) => {
        Toast.loading(t('图片加载中'), { cover: true, closeOnClickOverlay: false, duration: 0 });
        try {
            previewPatternObject = await tc.curCanvasClient.addImageById(v.path, tc.fabricW as number * 0.5);
            tc.curCanvasClient.getFabricCanvas().setActiveObject(previewPatternObject);
            tc.curCanvasClient.getFabricCanvas().renderAll();
            Toast.hide();
            if (onConfirmSuccess) {
                onConfirmSuccess();
            }
            tc?.markAsChanged?.(); // 标记为新更改
            console.log(tc.notEmptyCodes)

        } catch (error) {
            Toast.fail(t("失败，请重试一下"));
        }
    };

    const loadPatternList = async () => {
        try {
            const patterns: any = await http.get(apis.DESIGNER_PATTERN, {
                params: { page: page.current, limit: 80, status: 1, category_id: categoryId.current },
            });
            if (page.current === 1) {
                setPatternList(patterns);
                return;
            }
            setPatternList((pre: any) => {
                let cpList: any = cloneDeep(pre);
                cpList.total = patterns.total;
                cpList.list = [...cpList.list, ...patterns.list];
                return cpList;
            });
        } catch (error) { }
    };

    const loadPattern = async (groupId: number) => {
        if (groupId === curPatternGroupId) return;
        page.current = 1;
        categoryId.current = groupId;
        loadPatternList();
        setCurPatternGroupId(groupId);
    };


    const onLoadMore = async (done: () => void) => {
        page.current++;
        try {
            await loadPatternList();
        } catch (error) {
            page.current--;
        }
        done();
    };

    const fileOnChange = async (e: any) => {
        const input = e.target;
        if (input.files && input.files.length !== 0) {
            Toast.loading(t("上传中"), { cover: true, closeOnClickOverlay: false, duration: 0 });
            const file = input.files[0];
            try {
                const ossData: any = await uploadFile(apis.UPLOAD_IMAGE, file);
                Toast.hide();
                if (!ossData.data.url) {
                    Toast.fail(t("资源文件上传失败"));
                    return;
                }
                previewPattern({ path: ossData.data.url });
                input.value = '';
            } catch (error) {
                Toast.fail(t("资源文件上传失败"));
            }
        }
    };

    return (

        <div style={{
            bottom: 0,
            position: "relative",
            left: 0,
            zIndex: 11,
            background: "#FFFFFF",
            paddingBottom: tc.safeHeigth,
            overflowY: "auto"
        }}>
            <div style={{
                height: groupHeight,
                background: "#FFFFFF",
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
                padding: "0 5px"
            }}>
                <Swiper slidesPerView="auto" style={{ overflow: 'hidden' }}>
                    {patternGroups.map((v: any) => (
                        <SwiperSlide
                            key={v.id}
                            style={{ width: 'auto' }}
                            onClick={() => loadPattern(v.id)}
                        >
                            <div style={{
                                padding: '0 12px',
                                color: v.id === curPatternGroupId ? '#333333' : '#999999',
                                display: 'inline-block',
                                height: titleHeight,
                                lineHeight: titleHeight + 'px',
                                textAlign: 'center',
                                fontWeight: 500,
                                fontSize: 14,
                                cursor: 'pointer'
                            }}>{t(v.name)}</div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            <div id="scroll" style={{
                overflowY: 'auto', overflowX: 'hidden', padding: '0 5px', height: 'calc(100vh - 130px)',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none'
            }}>
                {patternList?.list && patternList?.list?.length !== 0 ? (
                    <div>
                        <Infiniteloading
                            loadIcon=""
                            containerId="scroll"
                            useWindow={false}
                            hasMore={patternList?.total !== patternList?.list?.length}
                            onLoadMore={onLoadMore}
                            style={{ paddingBottom: 12 }}
                        >
                            <div style={{ display: "grid", gridTemplateColumns: "repeat(4,auto)", gap: '16px', justifyItems: 'center' }}>
                                <input
                                    onChange={fileOnChange}
                                    accept='.jpg,.jpeg,.png'
                                    type='file'
                                    ref={uploadRef}
                                    style={{ display: "none" }}
                                />
                                <div onClick={() => uploadRef.current.click()} style={{
                                    width: 100, height: 100,
                                    border: '1px solid #EEE',
                                    overflow: "hidden",
                                    borderRadius: 4,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>
                                    <img style={{ width: "50%", cursor: 'pointer' }} src={UploadIcon} alt="" />
                                </div>
                                {patternList?.list.map((v: any) => (
                                    <div key={v.id} onClick={() => previewPattern(v)} style={{
                                        width: 100,
                                        height: 100,
                                        border: currentPatternId === v.id ? "2px solid #F57766" : "1px solid #EEE",
                                        overflow: "hidden",
                                        borderRadius: 4,
                                    }}>
                                        <img style={{ width: '100%', height: '100%', cursor: 'pointer' }} src={v.path + "?x-oss-process=image/resize,w_100"} alt="" />
                                    </div>
                                ))}
                            </div>
                        </Infiniteloading>
                    </div>
                ) : (
                    <div style={{ width: "100%", overflowX: "hidden" }}>
                        <Empty imageSize={Number(tc.fabricW) * 0.5 || 0} description={t('无数据')} />
                    </div>
                )}
            </div>
        </div>
    );
};

export default Index;
